/** The consent screen (PER-334). No em or en dashes anywhere here (UI copy rule). */
export const CONNECT_COPY = {
  pageTitle: 'Connect an app',
  heading: (host: string) => `${host} wants to work in Pertento as you`,
  calledItself: (name: string) => `It calls itself ${name}.`,
  intro:
    'It can only do what you can, narrowed to what you allow here. You can disconnect it at any time under Settings, Agent access.',
  returnTo: (host: string) => `After you choose, you go back to ${host}.`,
  loopback:
    'This app gets its answer on this computer (localhost). Continue only if you started it yourself, for example Claude Code.',
  scopesLabel: 'What it may do',
  notForYourRole: 'Your role cannot allow this.',
  nothingToAllow: 'The app did not ask for anything your role can allow, so it cannot be connected.',
  expiryLabel: 'Disconnects after',
  passwordHelp: 'A connected app keeps working after you sign out, so connecting one asks for your password again.',
  passkeyNote: 'You will confirm with your passkey too.',
  passkeyElsewhere: (places: readonly string[]) =>
    `Your passkey is registered on ${places.join(' and ')}, so it cannot confirm here. Add a passkey on this site to connect apps.`,
  passkeyElsewhereShort: 'Add a passkey on this site to connect apps.',
  managePasskeys: 'Manage passkeys',
  allow: 'Allow',
  allowing: 'Connecting',
  deny: 'Cancel',
  leaving: 'Going back to the app',
  loadFailed: 'This connection request could not be loaded.',
  connectFailed: 'Could not connect the app.',
  denyFailed: 'Could not cancel. Close this tab and go back to the app.',
  backHome: 'Go to Pertento',
  verified: 'Verified app',
  verifiedHelp: 'Pertento has checked that this is the real app.',
  unverified: 'Unverified app',
  unverifiedHelp:
    'Pertento has not checked who runs this app. Anyone can publish an app under any name. Continue only if you trust the site above and started this yourself.',
  optionsFailed: 'Your websites and passkey settings could not be loaded, so the app cannot be connected yet.',
  framed: 'For your safety, connect apps in a tab of their own. Open this page directly in your browser.',
} as const;
